function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.24 7.24l-8.82 8.82H.01v-4.41l8.82-8.82zm-8.42 6.5l-2.49-2.49-1 1v1.13h1.42v1.36h1.13zm4.35-9.11a.25.25 0 00-.18.07l-5.75 5.75a.25.25 0 00-.07.18.22.22 0 00.23.23.25.25 0 00.18-.07l5.75-5.75a.25.25 0 00.07-.18.22.22 0 00-.24-.23zm6.51.17l-1.76 1.76-4.41-4.41L11.27.4a1.33 1.33 0 011-.4 1.37 1.37 0 011 .4l2.49 2.48a1.41 1.41 0 01.39 1 1.36 1.36 0 01-.47.92z"
});

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16.07 16.07"
  }, props), _ref);
};

export default SvgPencil;